import cookie from 'react-cookies'
import { JWT_STORAGE_KEY } from 'portal-modules/common/constants/keys'
import getProjectConditions from 'portal-modules/common/utils/get-project-conditions'
const { isRP } = getProjectConditions()
import decode from 'jwt-decode'
import {
  RP_LEASE_ID,
  RP_PROPERTY_ID,
} from 'portal-modules/common//constants/keys'
import { setEncryptedCryptoData } from 'portal-modules/common/utils/crypto-encryption'

export const setSessionCookies = (
  cookieName,
  cookieValue,
  isCookiStringfy = false,
  overrideOptions = {},
) => {
  if (isRP && cookieName === JWT_STORAGE_KEY) {
    if (cookieValue) {
      const token = isCookiStringfy ? JSON.stringify(cookieValue) : cookieValue
      const { data } = decode(token)
      if (Object.keys(data).length) {
        const { leaseId = '', propertyId = '' } = data
        leaseId && setEncryptedCryptoData(RP_LEASE_ID, leaseId)
        propertyId && setEncryptedCryptoData(RP_PROPERTY_ID, propertyId)
      }
    }
  } else {
    const expires = new Date()
    expires.setDate(Date.now() + 1000 * 60 * 60 * 24 * 14)
    cookieValue = isCookiStringfy ? JSON.stringify(cookieValue) : cookieValue
    cookie.save(cookieName, cookieValue, {
      path: '/',
      secure: true,
      ...overrideOptions,
    })
  }
}

export const getSessionCookies = cookieName =>
  typeof cookie.load(cookieName) !== 'undefined' && cookie.load(cookieName)

export const removeSessionCookies = cookieName =>
  typeof cookie.load(cookieName) !== 'undefined' &&
  cookie.remove(cookieName, { path: '/' })
